import { put, takeLatest } from 'redux-saga/effects';
import { sendEmailAction, sendEmailErrorAction, sendEmailSuccessAction } from '../../store/shared/send-email.store';
import { sendEmailAPI } from '../../api/provider/booking/booking-provider';
import { authenticatedCall } from '../../utils/authenticated-call';


function* sendEmailSaga(data: any) {

  try {
    yield authenticatedCall(sendEmailAPI, data.payload)
    yield put(sendEmailSuccessAction())
  } catch (error: any) {
    yield put(sendEmailErrorAction(error.localizedMessage))
    return
  }
}


export function* sendEmailSagas() {
  yield takeLatest(sendEmailAction.type, sendEmailSaga);
}
